import {Country} from "../../../../region/types/Country";

export const gtmEcommerceCountryMap = {
    [Country.POLAND]: "Polska",
    [Country.SPAIN]: "Hiszpania"
};

export const getGtmEcommerceCountry = (country?: Country) => {
    const requestedCountry = country || Country.POLAND;
    return gtmEcommerceCountryMap[requestedCountry];
};
import {Country} from "../../../../region/types/Country";

export const gtmEcommerceCountryMap = {
    [Country.POLAND]: "Polska",
    [Country.SPAIN]: "Hiszpania"
};

export const getGtmEcommerceCountry = (country?: Country) => {
    const requestedCountry = country || Country.POLAND;
    return gtmEcommerceCountryMap[requestedCountry];
};
